import React, { useState, useEffect } from 'react';
import { formatDateTime } from '../../utils/formatDates';
import useLanguage from '../../customHooks/useLanguage';
import useTimeZone from '../../customHooks/useTimeZone';

const Clock = () => {
    const language = useLanguage();
    const timeZone = useTimeZone();

    const [date, setDate] = useState(new Date());

    function refreshClock() {
        setDate(new Date());
    }

    useEffect(() => {
        const timerId = setInterval(refreshClock, 1000);
        return function cleanup() {
            clearInterval(timerId);
        };
    }, []);

    return (
        <div style={{ width: '100%', textAlign: 'center' }}>
            <p> {formatDateTime(date, language, timeZone)}</p>
        </div>
    );
};

export default Clock;
